import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {TaskService} from '../../../../services/task.service';

@Component({
  selector: 'app-common-timer',
  templateUrl: './common-timer.component.html',
  styleUrls: ['../parts.css']
})
export class CommonTimerComponent implements OnInit {
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  // 定时
  timerConditionDisplayText = '定时'; // 定时默认文字
  timerConditionData: any; // 存放定时数据
  timerConditionVisible: boolean; // 定时pop是否关闭
  // 分组
  groupConditionVisible: boolean; // 分组POP是否关闭
  groupConditionId = null; // 分组选中ID
  groupConditionDisplayText = '分组'; // 条件二默认文字
  // 条件
  conditionData: any; // 存放条件筛选数据
  conditionVisible = false; // 条件pop
  // 其他
  isVisible = false; // 弹窗显示控制
  isConfirmLoading = false; // 确定按钮
  recipeId = null; // 自动化模板ID
  relationId = null;
  recipe: any;
  instanceData: any = {}; // 存放实例返填数据
  taskIntegrationData: any = {}; // 存放任务数据
  categorieId: string; // 存放当前目录ID
  backFillData: any; // 回填数据
  automation = {
    boardId: '',
    groupId: '',
    relationId: '',
    categoryId: '',
    tdScheduleConfig: {},
    schedulerConfig: {},
    taskMapping: {},
    conditions: []
  }; // 存放入参数据
  TimerType: string;
  @ViewChild('pulseCard', { static: true }) pulseCard: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService
  ) { }

  ngOnInit() {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
      if (this.recipe['configurationFields'] && this.recipe['configurationFields']['conditions']) {
        this.conditionData = this.recipe['configurationFields']['conditions']['options'];
      }
    }
    // 处理实例数据
    if (this.instanceData && this.instanceData.config) {
      if (this.instanceData.config.tdScheduleConfig) {
        this.timerConditionData = this.instanceData.config.tdScheduleConfig;
        this.timerConditionDisplayText = this.instanceData.config.tdScheduleConfig.description;
      } else if (this.instanceData.config.schedulerConfig) {
        this.timerConditionData = this.instanceData.config.schedulerConfig;
        this.timerConditionDisplayText = this.instanceData.config.schedulerConfig.description;
      }
      this.backFillData = this.instanceData.config.taskMapping;
      this.groupConditionId = this.instanceData.config.groupId;
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      for (let group of this.boardGroupData) {
        if (group.id === this.groupConditionId) {
          this.groupConditionDisplayText = group.title;
          break;
        }
      }
    }
    // 带入菜单ID
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    this.packageData(this.automation);
  }
  // 获取定时数据
  getTimerData(data) {
    if (data) {
      this.TimerType = data.type;
      if (this.TimerType === 'minutes') {
        this.automation.schedulerConfig = data;
        this.timerConditionDisplayText = this.automation.schedulerConfig['description'];
        delete this.automation['tdScheduleConfig'];
      } else {
        this.automation.tdScheduleConfig = data;
        this.timerConditionDisplayText = this.automation.tdScheduleConfig['description'];
        delete this.automation['schedulerConfig'];
      }
      this.timerConditionData = data;
      this.packageData(this.automation);
    }
  }

  closeTimer() {
    this.timerConditionVisible = false;
  }

  // 获取条件数据
  getConditionData(data) {
    this.automation.conditions = data;
    this.packageData(this.automation);
  }
  // 分组变更
  groupConditionChange(item) {
    this.groupConditionDisplayText = item.title;
    this.groupConditionId = item.id;
    this.automation.groupId = this.groupConditionId;
    this.groupConditionVisible = false;
    this.packageData(this.automation);
  }
  // 弹窗创建任务
  openTaskDialog() {
    this.isVisible = true;
  }
  // 弹窗确定事件
  handleOk() {
    this.pulseCard.onSubmit();
    this.isVisible = false;
  }
  // 弹窗关闭事件
  handleCancel() {
    this.isVisible = false;
  }
  // 获取任务创建数据
  getTaskIntegrationData(event) {
    this.taskIntegrationData = event;
    const obj: any = {};
    event.forEach((item, index) => {
      let mapObj: any;
      if (typeof item.mappingValue === 'string') {
        switch (item.type) {
          case 'dropdown':
            mapObj = {
              'fixedValue': {
                'ids': [item.mappingValue]
              }
            };
            break;
          case 'select':
            mapObj = {
              'fixedValue': {
                'option': item.mappingValue
              }
            };
            break;
          case 'button':
            mapObj = {
              'fixedValue': {
                'original': item.mappingValue
              }
            };
            break;
        }
      }
      if (item.type === 'dropdown' || item.type === 'select' || item.type === 'button') {
        obj[item.id] = mapObj;
      } else {
        const mpArr = [];
        item.mappingValue.forEach((m, i) => {
          mapObj = {
            'type': 'field',
            'sourceField': {
              'id': m.id,
              'type': m.type ? m.type : 'text',
              'title': m.title
            }
          };
          mpArr.push(mapObj);
        });
        mpArr.unshift({'type': 'text', 'text': item.mappingFirstValue});
        mpArr.push({'type': 'text', 'text': item.mappingEndValue});
        obj[item.id] = {
          'targetField': {
            'id': item.id,
            'title': item.title,
            'type': item.type,
          },
          'mappingParts': mpArr
        };
      }
      this.automation.taskMapping['mappingConfig'] = obj;
    });
    this.packageData(this.automation);
  }
  // 组件提交数据
  packageData(data) {
    const text = this.timerConditionDisplayText ? `${this.timerConditionDisplayText.slice(0, 24)}...` : this.timerConditionDisplayText;
    data.instanceDescription = text + ' ，当 条件 满足时，在 ' + this.groupConditionDisplayText + ' 中，创建 任务';
    this.nfDataChange.emit(data);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus(): boolean {
    return JSON.stringify(this.automation.tdScheduleConfig) !== '{}' &&
      this.automation.conditions && this.automation.conditions.length > 0 &&
      this.groupConditionId &&
      JSON.stringify(this.automation.taskMapping) !== '{}';
  }
}
